import React from 'react';
import clsx from 'clsx';
import selectors from '../hooks/selectors';
import fetch from '../hooks/fetch';

const BackgroundImage = ({ children, className, codes }) => {
  const { src, readStatus } = selectors.useImageFetcher({ codes });
  fetch.useFetchImages({ items: codes }, readStatus);

  return (
    <div className={clsx('aridhia-background-image', className)} style={{ backgroundImage: `url(${src})` }}>
      {children}
    </div>
  );
};

export default BackgroundImage;
